module.exports = __webpack_public_path__ + "img/3_187.5ef748a0.png";